import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import { convertToStandard } from 'appSrc/utils/list-article';
import TextTruncate from 'react-text-truncate';
import style from './styles/style.module.css';

import defaultListCoverImage from 'appSrc/assets/img/list/default_list_image.png';


class NarrowLACard extends PureComponent {
    constructor(props) {
        super( props );

        this.state = {
            videoPlaying: false,
        };
    }
    renderCoverImage = ( item ) => {
        const youtubeImg = item.video_id && convertYouTubeIdToImg( item.video_id );
        const coverImage = item.cover_image || youtubeImg || defaultListCoverImage;

        return (
            <div className={ style.imageWrapper }>
                <img src={ coverImage } />
            </div>
        );
    }
    convertHTMLString = ( input ) => {
        var output = input.replace( /<[^>]*>/gm, '' );
        return output;
    }



    render() {
        const item = convertToStandard( this.props.item );

        var description = this.convertHTMLString( item.text );

        return (
            <div className={ `${ style.narrowCard } ${ this.props.className }`.trim() }>
                <Link to={ item.internal_link } className={ style.backgroundLink }></Link>
                <div className={ style.content }>
                    <div className={ style.imageSizing }>
                        <AspectRatio ratio='5/4' className={ style.coverWrapper }>
                            { this.renderCoverImage( item ) }
                        </AspectRatio>
                    </div>
                    <div className={ style.info }>
                        <Link to={ item.internal_link } className={ style.listLink }>
                            <TextTruncate
                            text={ item.title }
                            title={ item.title } line={ 1 }
                            containerClassName={ style.name } />
                            { description &&
                                <TextTruncate
                                text={ description }
                                title={ description } line={ 2 }
                                containerClassName={ style.description } />
                            }
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
NarrowLACard.propTypes = {
    item: PropTypes.object.isRequired,
};
NarrowLACard.defaultProps = {
    className: '',
};

export default connect()( NarrowLACard );
